import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Spin } from 'antd';

let temp = null
function Guard ({ element, meta, handleRouteBefore, redirect,path}) {
  meta = meta || {}
  const location = useLocation()
  const { pathname } = location
  const navigate = useNavigate()
  if (temp === element) {
    return element
  }
  const pathRes = handleRouteBefore({ pathname, meta,redirect,path })
  if (handleRouteBefore && pathRes) {
    const pathResType = Object.prototype.toString.call(pathRes) === '[object Promise]'
    if (pathResType === 'Promise') {
      pathRes.then(res => {
        if (res && res !== pathname) {
          navigate(res, { replace: true })
        }
      })
    } else {
      if (pathRes && pathRes !== pathname) {
        element = <Navigate to={pathRes} replace={true} />
      }
    }
  }

  temp = element
  return element
}

let handleRouteBefore = null
// 设置路由导航守卫函数
function setRouteBefore (fn) {
  handleRouteBefore = fn
}

// 路由懒加载
function lazyLoad (route) {
  const {component, meta,directLoad} = route
  const Element = directLoad?component:React.lazy(component)
  const lazyElement = (
    <React.Suspense fallback={(
      <Spin className='common-spin-container'></Spin>
    )}>
      <Element _meta={meta}/>
    </React.Suspense>
  )
  return (
    <Guard
      {...route}
      element={lazyElement}
      handleRouteBefore={handleRouteBefore}
    />
  )
}

// 路由配置列表数据转换
function transformRoutes (routes=[]) {
  return routes.map(route => {
    return {
      ...route,
      element: lazyLoad(route),
      children: transformRoutes(route.children)
    }
  })
}

export {
  setRouteBefore,
  transformRoutes,
}
